import { useLocation } from 'react-router-dom'
import HomePage from 'components/templates/navigationPageTemplates/HomePage'
import LeftPanelTemplate from 'components/templates/LeftPanelTemplate'
import LeftPanelTitle from 'components/atoms/container/LeftPanelTitle'
import { useTranslation } from 'react-i18next'
import UserSurveyCard from 'components/organisms/assessments/UserSurveyCard'
import colors from 'styles/colors'

const UserSurvey = () => {
  const { t } = useTranslation()
  const location = useLocation()

  return (
    <HomePage customizedBodyWidth={true}>
      <LeftPanelTemplate
        titleGroup={
          <LeftPanelTitle
            title={t('onboarding.insightSurvey.greetings')}
            subText={t('userInsightSurvey.checkYourExperiences')}
            isLightText={true}
          />
        }
        leftPanelBackground={colors.MidnightTeal400}>
        <UserSurveyCard
          pendingSurvey={location.state?.pendingSurvey}
        />
      </LeftPanelTemplate>
    </HomePage>
  )
}

export default UserSurvey
